module.exports = __webpack_public_path__ + "img/u16.ce0a3251.png";